import React from 'react';
import { Layout, Menu, Dropdown, Avatar, Space } from 'antd';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { UserOutlined, CarOutlined, OrderedListOutlined, HomeOutlined, LogoutOutlined } from '@ant-design/icons';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../store/store';
import { logout } from '../store/slices/authSlice';

const { Header, Content, Footer } = Layout;

const UserLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { user, isAuthenticated } = useSelector((state: RootState) => state.auth);

  const menuItems = [
    {
      key: '/',
      icon: <HomeOutlined />,
      label: 'ホーム',
    },
    {
      key: '/rental',
      icon: <CarOutlined />,
      label: 'レンタカー',
    },
    {
      key: '/ride',
      icon: <CarOutlined />,
      label: 'タクシー',
    },
    {
      key: '/profile',
      icon: <UserOutlined />,
      label: 'マイページ',
    },
  ];

  const handleMenuClick = (key: string) => {
    navigate(key);
  };

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  const userMenu = (
    <Menu
      items={[
        {
          key: 'profile',
          icon: <UserOutlined />,
          label: 'プロフィール',
          onClick: () => navigate('/profile'),
        },
        {
          key: 'logout',
          icon: <LogoutOutlined />,
          label: 'ログアウト',
          onClick: handleLogout,
        },
      ]}
    />
  );

  // 临时移除认证检查，允许アクセス所有ページ进行演示
  // if (!isAuthenticated) {
  //   navigate('/login');
  //   return null;
  // }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#fff', borderBottom: '1px solid #f0f0f0' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div className="logo" style={{ marginRight: 20, fontSize: 20, fontWeight: 'bold', color: '#1890ff' }}>
            AES Mobility
          </div>
          <Menu
            mode="horizontal"
            selectedKeys={[location.pathname]}
            items={menuItems}
            onClick={({ key }) => handleMenuClick(key)}
            style={{ border: 'none', flex: 1 }}
          />
        </div>
        <div className="user-info">
          <Dropdown overlay={userMenu} placement="bottomRight">
            <Space style={{ cursor: 'pointer' }}>
              <Avatar icon={<UserOutlined />} />
              <span>
                {user?.profile?.firstName && user?.profile?.lastName 
                  ? `${user.profile.lastName} ${user.profile.firstName}`
                  : user?.email || 'ユーザー'
                }
              </span>
            </Space>
          </Dropdown>
        </div>
      </Header>
      <Content style={{ background: '#f0f2f5' }}>
        <Outlet />
      </Content>
      <Footer style={{ textAlign: 'center', background: '#fff', borderTop: '1px solid #f0f0f0' }}>
        AES Mobility ©2024 Created by AES Team
      </Footer>
    </Layout>
  );
};

export default UserLayout;